import { render, staticRenderFns } from "./edit-logistics.vue?vue&type=template&id=c486bc22"
import script from "./edit-logistics.vue?vue&type=script&lang=ts"
export * from "./edit-logistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports